(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["before-after"] && !Shopify.designMode) return;
  try {
    (function () {
    const root = document.querySelector('.hair-proof__compare');
    if (!root) return;
    const after = root.querySelector('.hair-proof__after');
    const handle = root.querySelector('.hair-proof__handle');

    const clamp = (n, min, max) => Math.max(min, Math.min(max, n));
    const setPos = (pct) => {
      after.style.setProperty('--pos', pct);
      handle.style.left = pct + '%';
      handle.setAttribute('aria-valuenow', Math.round(pct));
    };
    const posFrom = (e) => {
      const r = root.getBoundingClientRect();
      const x = (e.touches ? e.touches[0].clientX : e.clientX) - r.left;
      return clamp((x / r.width) * 100, 0, 100);
    };

    let dragging = false,
      pending = null,
      targetPct = 50;

    const start = (e) => {
      dragging = true;
      targetPct = posFrom(e);
      setPos(targetPct);
      e.preventDefault();
    };
    const move = (e) => {
      if (!dragging) return;
      targetPct = posFrom(e);
      if (pending) return;
      pending = requestAnimationFrame(() => {
        setPos(targetPct);
        pending = null;
      });
    };
    const stop = () => {
      dragging = false;
    };

    handle.addEventListener('mousedown', start);
    handle.addEventListener('touchstart', start, { passive: false });
    window.addEventListener('mousemove', move);
    window.addEventListener('touchmove', move, { passive: false });
    window.addEventListener('mouseup', stop);
    window.addEventListener('touchend', stop);

    root.addEventListener('pointerdown', (e) => setPos(posFrom(e)));

    handle.addEventListener('keydown', (e) => {
      const step = e.shiftKey ? 10 : 2;
      const now = parseFloat(after.style.getPropertyValue('--pos') || '50') || 50;
      if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) {
        e.preventDefault();
        if (e.key === 'ArrowLeft') setPos(clamp(now - step, 0, 100));
        if (e.key === 'ArrowRight') setPos(clamp(now + step, 0, 100));
        if (e.key === 'Home') setPos(0);
        if (e.key === 'End') setPos(100);
      }
    });

    setPos(parseFloat(root.dataset.pos || '50'));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["more-information-accordian"] && !Shopify.designMode) return;
  try {
    (function () {
  var items = document.querySelectorAll('.morinfo-item');
  if (!items.length) return;

  items.forEach(function (item) {
    var btn = item.querySelector('.morinfo-header');
    if (!btn) return;

    btn.addEventListener('click', function () {
      var isOpen = item.classList.contains('active');

      /* Close all */
      items.forEach(function (other) {
        other.classList.remove('active');
        var ob = other.querySelector('.morinfo-header');
        if (ob) ob.setAttribute('aria-expanded', 'false');
      });

      /* Open this one if it was closed */
      if (!isOpen) {
        item.classList.add('active');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
